import StickyScrollAnimation from './StickyScrollAnimation';
import SpotLight from './Spotlight';

const FoundersSpotlight = () => {
	const FetchFoundersSpotlightData = (page) => {
		const url = new URL('/wp-json/api/v1/founders-spotlight', process.env.MIX_BASE_URL);
		
		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce': wp_ajax.nonce,
			},
			body: JSON.stringify({
				page: page,
			}),
		})
		.then(response => {
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			return response.json();
		})
		.then(result => {
			$('.spotlight-list').html(result.html);
			if (result.is_last) {
				$('.bg-load-spotlights').hide();
				$('.bg-hide-spotlights').show();
			} else {
				$('.bg-load-spotlights').show();
				$('.bg-hide-spotlights').hide();
			}
			SpotLight.create();
			$('.bg-load-spotlights').html(`Load More`);
		})
		.catch(error => {
			console.error('Error:', error);
		});
	};

	$('.bg-load-spotlights').on('click', () => {
		StickyScrollAnimation.create({
			selector: document.querySelector('[data-sticky-scroll'),
			trigger: document.querySelector('[data-sticky-scroll-trigger]'),
		});

		let page = $('.bg-load-spotlights').data('page');
		page += 1;
		$('.bg-load-spotlights').data('page', page);
		$('.bg-load-spotlights').html(`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="16px" height="16px" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid">
      <circle cx="12" cy="12" fill="none" stroke="#ffffff" stroke-width="2" r="8" stroke-dasharray="18.84955592153876 8.283185307179586">
      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 12 12;360 12 12" keyTimes="0;1"/>
      </circle>
    </svg>`);

		FetchFoundersSpotlightData(page);

	});

	$('.bg-hide-spotlights').on('click', () => {
		let page = 1;
		StickyScrollAnimation.destroy();

		setTimeout(() => {
			$('.bg-load-spotlights').data('page', page);
			FetchFoundersSpotlightData(page);
		}, 300);
	});
};

export default FoundersSpotlight;
